/* eslint-disable */
import React, { memo, useEffect, useState, useRef } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAuthSession,
  attachmentsDownload,
  timestampToDateTime,
} from "../Helpers/common";
import { _sendChatRoomFiles, _sendLoadMoreChatRoomFiles } from "../../SocketIo";
import { setChatFiles, setLoaderMoreChatFiles } from "../redux/chatSlice";
import ImagePreviewModal from "../models/ImagePreviewModal";
import { alertMsg } from "../util/alertMsg";
import { getFilesData } from "../Helpers/chatCommon";
import CustomChatLoader from "../customComponent/customChatLoader";
import FileCard from "./fileCard";

export const getFileIcon = (filename) => {
  const ext = filename?.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "html":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-filetype-html"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zm-9.736 7.35v3.999h-.791v-1.714H1.79v1.714H1V11.85h.791v1.626h1.682V11.85h.79Zm2.251.662v3.337h-.794v-3.337H4.588v-.662h3.064v.662zm2.176 3.337v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596H9.93L8.79 11.85h-.805v3.999zm4.71-.674h1.696v.674H12.61V11.85h.79v3.325Z"
          />
        </svg>
      );
    case "json":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-filetype-json"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM4.151 15.29a1.2 1.2 0 0 1-.111-.449h.764a.58.58 0 0 0 .255.384q.105.073.25.114.142.041.319.041.245 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .084-.29.39.39 0 0 0-.152-.326q-.152-.12-.463-.193l-.618-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.352-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.192-.272.528-.422.337-.15.777-.149.456 0 .779.152.326.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.246-.181.9.9 0 0 0-.37-.068q-.324 0-.512.152a.47.47 0 0 0-.185.384q0 .18.144.3a1 1 0 0 0 .404.175l.621.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-3.104-.033a1.3 1.3 0 0 1-.082-.466h.764a.6.6 0 0 0 .074.27.5.5 0 0 0 .454.246q.285 0 .422-.164.137-.165.137-.466v-2.745h.791v2.725q0 .66-.357 1.005-.355.345-.985.345a1.6 1.6 0 0 1-.568-.094 1.15 1.15 0 0 1-.407-.266 1.1 1.1 0 0 1-.243-.39m9.091-1.585v.522q0 .384-.117.641a.86.86 0 0 1-.322.387.9.9 0 0 1-.47.126.9.9 0 0 1-.47-.126.87.87 0 0 1-.32-.387 1.55 1.55 0 0 1-.117-.641v-.522q0-.386.117-.641a.87.87 0 0 1 .32-.387.87.87 0 0 1 .47-.129q.265 0 .47.129a.86.86 0 0 1 .322.387q.117.255.117.641m.803.519v-.513q0-.565-.205-.973a1.46 1.46 0 0 0-.59-.63q-.38-.22-.916-.22-.534 0-.92.22a1.44 1.44 0 0 0-.589.628q-.205.407-.205.975v.513q0 .562.205.973.205.407.589.626.386.217.92.217.536 0 .917-.217.384-.22.589-.626.204-.41.205-.973m1.29-.935v2.675h-.746v-3.999h.662l1.752 2.66h.032v-2.66h.75v4h-.656l-1.761-2.676z"
          />
        </svg>
      );
    case "csv":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-filetype-csv"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
          />
        </svg>
      );
    case "xls":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-filetype-xls"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"
          />
        </svg>
      );
    case "xlsx":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-filetype-xlsx"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"
          />
        </svg>
      );
    case "zip":
    case "rar":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-file-zip"
          viewBox="0 0 16 16"
        >
          <path d="M6.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599zm2 0h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243z" />
          <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm5.5-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9v1H8v1h1v1H8v1h1v1H7.5V5h-1V4h1V3h-1V2h1z" />
        </svg>
      );
    case "pdf":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-filetype-pdf"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
          />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          className="bi bi-file-earmark"
          viewBox="0 0 16 16"
        >
          <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
        </svg>
      );
  }
};

const ChatboardFiles = () => {
  const dispatch = useDispatch();
  const {
    attendeeData,
    chatRoom,
    chatFiles,
    loaderChatFilesData,
    loaderMoreChatFiles,
    chatboardSelectedTab,
    hasMoreChatFiles,
  } = useSelector((state) => state.chat);

  const allAttendeeList = useSelector((state) => state.call.allAttendeeList);
  const authSession = getAuthSession();
  const [photos, setPhotos] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [attachmentItem, setAttachmentItem] = useState({});
  const [downloading, setDownloading] = useState([]);
  const [showAllPhotos, setShowAllPhotos] = useState(false);
  const scrollRef = useRef(null);
  let companyID = attendeeData?.company_id;
  let senderID = authSession?.user_unique_key;

  useEffect(() => {
    if (chatboardSelectedTab === "files" && chatRoom) {
      const filesData = getFilesData(chatRoom);
      if (filesData.length > 0) {
        dispatch(setChatFiles(filesData));
      } else {
        _sendChatRoomFiles({
          company_id: companyID,
          documentID: chatRoom,
          user_id: senderID,
        });
      }
    }
  }, [chatboardSelectedTab]);

  useEffect(() => {
    if (chatFiles?.length) {
      const photosArr = [];
      const docsArr = [];
      chatFiles.forEach((msg) => {
        if (Array.isArray(msg.attachments)) {
          msg.attachments.forEach((att) => {
            const { attachments, ...msgWithoutAttachments } = msg;
            const mergedObj = { ...att, ...msgWithoutAttachments };
            if (
              ["jpeg", "jpg", "png", "gif", "mp4", "mov"].includes(
                att.attachment_type,
              )
            ) {
              photosArr.push(mergedObj);
            } else {
              docsArr.push(mergedObj);
            }
          });
        }
      });

      setPhotos(photosArr);
      setDocuments(docsArr);
    }
  }, [chatFiles]);

  const loadMore = () => {
    if (chatFiles.length === 0) return;
    dispatch(setLoaderMoreChatFiles(true));
    const lastMessage = chatFiles[chatFiles.length - 1];
    if (lastMessage) {
      _sendLoadMoreChatRoomFiles({
        company_id: companyID,
        documentID: chatRoom,
        user_id: senderID,
        timestamp: lastMessage.timestamp,
      });
    }
  };

  const handleScroll = () => {
    if (!scrollRef.current || loaderMoreChatFiles || !hasMoreChatFiles) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      loadMore();
    }
  };

  const openModal = (file) => {
    if (["png", "jpg", "jpeg", "jfif"].includes(file?.attachment_type)) {
      setAttachmentItem(file);
      setIsOpenModal(true);
    }
  };

  const closeImagePreviewModal = () => {
    setAttachmentItem({});
    setIsOpenModal(false);
  };

  const downloadAttachment = (file) => {
    const fileId = file.attachmentName;
    setDownloading((prev) => [...prev, fileId]);
    attachmentsDownload(
      fileId,
      file.attachmentName,
      file.originalFileName,
      setDownloading,
      downloading,
      file.attachment_type,
      file,
    );
  };

  return (
    <>
      <div
        className={`files ${chatFiles.length === 0 ? "no-msg" : ""}`}
        ref={scrollRef}
        onScroll={handleScroll}
      >
        {loaderChatFilesData ? (
          <CustomChatLoader />
        ) : chatFiles.length === 0 ? (
          <ChatFilesNotFound />
        ) : !showAllPhotos ? (
          <>
            {/* Photos preview */}
            {photos.length > 0 && (
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="text-label mb-0">Photos & Videos</label>
                  {photos.length > 8 && (
                    <a
                      href={void 0}
                      className="d-flex align-items-center gap-1 text-orange"
                      onClick={() => setShowAllPhotos(true)}
                    >
                      See all
                    </a>
                  )}
                </div>
                <div className="d-flex overflow-auto gap-1">
                  {photos.slice(0, 8).map((file, idx) => {
                    console.log("🚀 ~ ChatboardFiles ~ file:", file);
                    const isDownloading = downloading.includes(
                      file.attachmentName,
                    );

                    return (
                      <FileCard
                        key={idx}
                        file={file}
                        isDownloading={isDownloading}
                        downloadAttachment={downloadAttachment}
                        openModal={openModal}
                      />
                      // <div
                      //   key={idx}
                      //   className="block-files"
                      //   onClick={() => openModal(file)}
                      // >
                      //   <img
                      //     src={file.imagePreview || file.url}
                      //     alt={file.originalFileName}
                      //     className="rounded border"
                      //     style={{
                      //       width: "100%",
                      //       height: "100%",
                      //       objectFit: "cover",
                      //       cursor: "pointer",
                      //     }}
                      //   />

                      //   {isDownloading ? (
                      //     <div className="actions position-relative top-0">
                      //       <div className={"downloading-loader actions"}>
                      //         <div className={"spin"}></div>
                      //       </div>
                      //     </div>
                      //   ) : (
                      //     <div className="actions">
                      //       <button
                      //         className="attached_file_btn"
                      //         onClick={(e) => {
                      //           e.stopPropagation();
                      //           downloadAttachment(file);
                      //         }}
                      //       >
                      //         <svg width="15" viewBox="2 4 20 16">
                      //           <path
                      //             fill="#ffffff"
                      //             d="m12 16 4-5h-3V4h-2v7H8z"
                      //           ></path>
                      //           <path
                      //             fill="#ffffff"
                      //             d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                      //           ></path>
                      //         </svg>
                      //       </button>
                      //     </div>
                      //   )}
                      // </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Documents list */}
            {documents.length > 0 && (
              <div>
                <label className="text-label">Documents</label>
                <ul className="list-group">
                  {documents.map((file, idx) => {
                    const isDownloading = downloading.includes(
                      file.attachmentName,
                    );
                    let username = "";
                    allAttendeeList.some((v) => {
                      if (v?.user_id == file.senderID) {
                        username = v.name;
                      }
                    });
                    return (
                      <li
                        key={idx}
                        className="list-group-item d-flex align-items-center justify-content-between"
                      >
                        <div className="d-flex align-items-center">
                          <div className="avatar">
                            {getFileIcon(file.originalFileName)}
                          </div>
                          <div>
                            <span className="fw-semibold">
                              <strong>{file.originalFileName}</strong>
                            </span>
                            <div className="small text-muted">
                              Shared by {username} on{" "}
                              {timestampToDateTime(file.timestamp)}
                            </div>
                          </div>
                        </div>
                        {isDownloading ? (
                          <div className="actions position-relative top-0">
                            <div className={"downloading-loader actions"}>
                              <div className={"spin"}></div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="actions position-relative top-0"
                            onClick={() => downloadAttachment(file)}
                          >
                            <button className="attached_file_btn">
                              <svg width="15" viewBox="2 4 20 16">
                                <path
                                  fill="#ffffff"
                                  d="m12 16 4-5h-3V4h-2v7H8z"
                                ></path>
                                <path
                                  fill="#ffffff"
                                  d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {/* Loader for docs */}
            {loaderMoreChatFiles && <CustomChatLoader />}
            {photos.length === 0 && documents.length === 0 && (
              <p className="text-center text-muted">No files found.</p>
            )}
          </>
        ) : (
          <>
            {/* All photos mode */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="text-label mb-0">Photos & Videos</label>
              <a
                href={void 0}
                className="d-flex align-items-center gap-1 text-orange"
                onClick={() => setShowAllPhotos(false)}
              >
                Back
              </a>
            </div>
            <div className="d-flex overflow-auto gap-1 flex-wrap">
              {photos.map((file, idx) => {
                console.log("🚀 ~ ChatboardFiles ~ file:", file);
                const isDownloading = downloading.includes(file.attachmentName);
                return (
                  <FileCard
                    key={idx}
                    file={file}
                    isDownloading={isDownloading}
                    downloadAttachment={downloadAttachment}
                    openModal={openModal}
                  />
                  // <div
                  //   key={idx}
                  //   className="block-files"
                  //   onClick={() => openModal(file)}
                  //   style={{ cursor: "pointer" }}
                  // >
                  //   <img
                  //     src={file.imagePreview || file.url}
                  //     alt={file.originalFileName}
                  //     className="img-fluid rounded border"
                  //     style={{
                  //       height: "100%",
                  //       objectFit: "cover",
                  //       width: "100%",
                  //     }}
                  //   />
                  //   {isDownloading ? (
                  //     <div className="actions position-relative top-0">
                  //       <div className={"downloading-loader actions"}>
                  //         <div className={"spin"}></div>
                  //       </div>
                  //     </div>
                  //   ) : (
                  //     <div className="actions">
                  //       <button
                  //         className="attached_file_btn"
                  //         onClick={(e) => {
                  //           e.stopPropagation();
                  //           downloadAttachment(file);
                  //         }}
                  //       >
                  //         <svg width="15" viewBox="2 4 20 16">
                  //           <path
                  //             fill="#ffffff"
                  //             d="m12 16 4-5h-3V4h-2v7H8z"
                  //           ></path>
                  //           <path
                  //             fill="#ffffff"
                  //             d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                  //           ></path>
                  //         </svg>
                  //       </button>
                  //     </div>
                  //   )}
                  // </div>
                );
              })}
            </div>

            {/* Loader for photos */}
            {loaderMoreChatFiles && (
              <div className="text-center my-3">
                <Spinner animation="border" />
              </div>
            )}
          </>
        )}
      </div>
      {isOpenModal && (
        <ImagePreviewModal
          show={true}
          closeModal={closeImagePreviewModal}
          attachmentItem={attachmentItem}
        />
      )}
    </>
  );
};

export default memo(ChatboardFiles);

const ChatFilesNotFound = () => {
  return (
    <p className="text-center">
      <b>{alertMsg.nothingFiles}</b>
      <br />
      {alertMsg.msgFilesNotFound}
      <br />
    </p>
  );
};
